/**
 * Copyright (c) 2026 Farelanes LLC. All rights reserved.
 *
 * UI: Mobile Nav Bar Buttons.
 */

import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { LoginButton } from "../../buttons/LoginButton";
import { LogoutButton } from "../../buttons/LogoutButton";
import { SignupButton } from "../../buttons/SignupButton";
import {SignupButtonMobile} from "../../buttons/SignupButtonMobile";
import {LoginButtonMobile} from "../../buttons/LoginButtonMobile";
import {LogoutButtonMobile} from "../../buttons/LogoutButtonMobile";
import Ticker from "../../Ticker";

export const MobileNavBarButtons = () => {
  const { user, isAuthenticated } = useAuth0();

  return (
    <div className="MobileNavBar__buttons">
      {!isAuthenticated && (
        <>
          <SignupButtonMobile />
          <LoginButtonMobile />
        </>
      )}
      {isAuthenticated && (
        <>
          {/*<LogoutButtonMobile />*/}
          <div style={{ textAlign: "center" }}>

            <p>Logged as {user.email}&nbsp;&nbsp;&nbsp;Build: FRV-2.1.0</p>
          </div>
        </>
      )}
    </div>
  );
};
